/**
 * A registration as it appears in a unit's address (gitaumoses4/chukua#390): `KDB 105J` is `/fleet/units/KDB-105J`. Upper case,
 * every run of anything but letters and digits one dash, none at either end. The API matches a registration with the same rule
 * in SQL (`CouplingsRepository.findByRegistrationSlug`), so keep the two in step.
 */
export function registrationSlug(registration: string): string {
  return registration
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
